import { css as t, styled as r } from "styled-components";
import { containerStyle as e } from "../../styles/grid.js";
import { Caption as i } from "../../styles/typography/index.js";
import { Colors as n } from "../../styles/colors/index.js";
import { Theme as a } from "../../styles/themes/index.js";
const o = t`
  color: rgb(${n.Graphite});
  button {
    color: rgb(${n.Graphite});
  }
`, b = r.div`
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: space-between;
  ${e}
`, c = r.div`
  display: flex;
  align-items: center;

  i {
    font-size: 24px;
    margin-right: 8px;
  }
`, $ = r.div`
  ${i}
  text-align: start;
  margin-right: 8px;

  &:only-child {
    margin-right: 16px;
  }
`, m = r.button`
  background: transparent;
  display: flex;
  align-items: center;

  i {
    font-size: 24px;
  }
`, u = r.div`
  ${o}
  background: rgb(${n.Alien});
`, f = r.div`
  ${o}
  background: rgb(${a.colors.Zulu});
`, C = r.div`
  ${o}
  background: rgb(${n.Mint});
  cursor: pointer;

  ${c} {
    i {
      color: rgb(${n.Green});
    }
  }
`, x = r.div`
  ${o}
  background: rgb(${n.Graphite});
  color: rgb(${n.Porcelain});

  button {
    color: rgb(${n.Porcelain});
  }
`, B = r.div`
  ${o}
  background: rgb(${n.Yellow});
`;
export {
  $ as BannerCaption,
  m as BannerCloseButton,
  B as BannerContainerAlert,
  x as BannerContainerDefault,
  f as BannerContainerError,
  C as BannerContainerInfo,
  u as BannerContainerSuccess,
  c as BannerContent,
  b as BannerContentContainer
};
